import { camelCase, isEmpty } from 'lodash';
import projectResource from '../../../locales/th/project.json';

export function getProjectInfomationConfig(
  zone,
  district,
  road,
  transportations,
  level,
  developer,
  statusDevelopment,
  completionDate,
  startDate,
) {
  return [
    {
      label: projectResource.projectInformation.locationZone + ':',
      value: zone,
      hasLink: true,
    },
    {
      label: projectResource.projectInformation.locationDistrict + ':',
      value: district,
      hasLink: true,
    },
    {
      label: projectResource.projectInformation.locationRoad + ':',
      value: road,
      hasLink: true,
    },
    {
      label: projectResource.projectInformation.nearbyTransport + ':',
      value: transportations,
      hasLink: true,
    },
    {
      label: projectResource.projectInformation.priceLevel + ':',
      value: !isEmpty(level) ? level.label : '',
      hasLink: false,
    },
    {
      label: projectResource.projectInformation.projectOwner + ':',
      value: developer.name,
      hasLink: false,
    },
    {
      label: projectResource.projectInformation.projectStatus + ':',
      value: !isEmpty(statusDevelopment.label)
        ? projectResource.projectInformation[camelCase(statusDevelopment.label)]
        : '',
      hasLink: false,
    },
    {
      label: projectResource.projectInformation.finishDate + ':',
      value: completionDate,
      hasLink: false,
    },
    {
      label: projectResource.projectInformation.startDate + ':',
      value: startDate,
      hasLink: false,
    },
  ];
}
